import { GeneralResponse } from '../models/generalResponse'

export function closeSession(sessionRepository, contextData, requestData) {
  return sessionRepository.closeSession(contextData, requestData).then(data => new GeneralResponse(data));
}